exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".el-form-item[data-v-5b81be27]{margin-bottom:0}.el-radio-group[data-v-5b81be27]{margin-top:8px;display:flex}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-5b81be27&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/xiaoyuan/GX/schoolManage.vue
// module id = 541
// module chunks = 0